import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AppState,
  CustomerVerificationFormSlice,
} from '../interfaces/store.interface';

export const initialState: CustomerVerificationFormSlice = {
  CustomerVerificationFormData: {
    lastFourSocial: '',
    phoneNumber: '',
  },
  transmitToken: '',
  piiFormEvent: {
    dataReason: '',
    dataType: '',
    dataObject: '',
  },
};

export const customerVerificationForm = 'customerVerificationForm';

export const customerVerificationFormSlice = createSlice({
  name: customerVerificationForm,
  initialState,
  reducers: {
    addFormData(
      state,
      action: PayloadAction<{
        lastFourSocial: number | string;
        phoneNumber: number | string;
      }>,
    ) {
      state.CustomerVerificationFormData = action.payload;
    },
    setTransmitToken(state, action: PayloadAction<string>) {
      state.transmitToken = action.payload;
    },
    setPiiFormEvent(state, action) {
      state.piiFormEvent = action.payload;
    },
  },
});

export const { addFormData, setTransmitToken, setPiiFormEvent } =
  customerVerificationFormSlice.actions;

export default customerVerificationFormSlice.reducer;

export const getPiiFormData = (state: AppState) =>
  state.customerVerificationForm.piiFormEvent;
